/* ------------------------------------------------------------------ */
/* Centralized content: portfolio, assets, leadership                  */
/* ------------------------------------------------------------------ */

export const PORTFOLIO_IMG = {
  chittaRetreat:
    "/assets/g4imvvul_Chitta-Retreat.jpg",
  berriver:
    "/assets/zv2i0yeu_Long-Bien-Barrier.jpg",
  thangLong:
    "/assets/1thymdqv_Than-Long.jpg",
  homepageDivider:
    "/assets/adnnzarn_section-divider.png",
  chittaCenter:
    "/assets/q1ag9ajt_Hall.jpeg",
  chittaHealthspan:
    "/assets/4bkxivuc_CHITTA-GROUP.jpg",
  partner:
    "/assets/1u8j3q98_partner.jpg",
  dongAnh:
    "/assets/unsplash-1583417319070.jpg",
  hanoiBuilding:
    "/assets/9eitpmqk_hanoi-building.jpg",
  luxuryHealthcare:
    "/assets/koygfzka_luxury-healthcare.jpg",
};

/* ------------------------------------------------------------------ */
/* Portfolio Companies (linked from About + Investments)               */
/* ------------------------------------------------------------------ */
export const PORTFOLIO_COMPANIES = [
  {
    slug: "hanco-9",
    name: "Hanco 9",
    name_vi: "Hanco 9",
    focus: "Property Development",
    focus_vi: "Phát triển bất động sản",
    sector: "Real Estate",
    sector_vi: "Bất động sản",
    keyAssets: ["Berriver Long Bien", "Dong Anh Landholding"],
    keyAssets_vi: ["Berriver Long Biên", "Quỹ đất Đông Anh"],
    img: PORTFOLIO_IMG.berriver,
    short: "Property Development",
    short_vi: "Phát triển bất động sản",
    body: [
      "Hanco 9 is the Group's real estate development and infrastructure platform, focused on residential, industrial, and mixed-use assets across Northern Vietnam.",
      "The company has delivered more than 1,000 residential units and over 18,000 m² of industrial leasable space, with completed assets retained as part of the Group's long-term portfolio strategy.",
      "Through disciplined planning, capital stewardship, and operational execution, Hanco 9 plays a foundational role in expanding the Group's real asset platform across high-growth economic corridors in Vietnam.",
    ],
    body_vi: [
      "Hanco 9 là công ty phát triển bất động sản và hạ tầng trực thuộc Tập đoàn, tập trung vào các tài sản nhà ở, bất động sản công nghiệp và khu phức hợp tại miền Bắc, Việt Nam.",
      "Đến nay, công ty đã bàn giao hơn 1.000 căn hộ nhà ở và đưa vào khai thác trên 18.000 m² mặt bằng công nghiệp cho thuê. Các dự án sau khi hoàn thiện tiếp tục được giữ lại khai thác, đóng vai trò là nguồn lực chiến lược trong phát triển danh mục đầu tư dài hạn của Tập đoàn.",
      "Với định hướng quy hoạch bài bản, quản trị nguồn vốn chặt chẽ và năng lực thực thi vượt trội, Hanco 9 là đơn vị mũi nhọn trong hệ sinh thái Tập đoàn, góp phần mở rộng quy mô danh mục tài sản thực của Unik Holdings tại các hành lang kinh tế trọng điểm, có tốc độ tăng trưởng nhanh tại Việt Nam.",
    ],
  },
  {
    slug: "property-one",
    name: "Property One",
    name_vi: "Property One",
    focus: "Office Leasing & Operations",
    focus_vi: "Quản lý vận hành & Cho thuê văn phòng",
    sector: "Real Estate",
    sector_vi: "Bất động sản",
    keyAssets: ["Thang Long Tower"],
    keyAssets_vi: ["Toà nhà Thăng Long"],
    img: PORTFOLIO_IMG.thangLong,
    short: "Office Leasing & Operations",
    short_vi: "Quản lý vận hành & Cho thuê văn phòng",
    body: [
      "Property One is the Group's commercial asset management platform, overseeing office leasing, tenant engagement, operational performance, and long-term capital planning across the Group's office portfolio in Hanoi.",
      "The platform prioritises occupancy stability, tenant retention, and asset quality, with performance driven through disciplined operations and long-term stewardship.",
      "Property One plays an important role in preserving asset value, strengthening portfolio resilience, and supporting sustainable long-term growth.",
    ],
    body_vi: [
      "Property One là doanh nghiệp trực thuộc Tập đoàn, hoạt động trong lĩnh vực quản lý tài sản thương mại, chịu trách nhiệm giám sát hoạt động cho thuê văn phòng, kết nối khách hàng, tối ưu hóa hiệu suất vận hành và lập kế hoạch giải ngân vốn cho toàn bộ khối văn phòng tại Hà Nội.",
      "Ưu tiên hàng đầu của đơn vị là duy trì tỷ lệ lấp đầy ổn định, và bảo đảm chất lượng tài sản thông qua quy trình quản trị và vận hành chuyên nghiệp.",
      "Property One đóng vai trò then chốt trong việc bảo toàn giá trị tài sản, nâng cao năng lực thích ứng của danh mục đầu tư và hỗ trợ mục tiêu tăng trưởng bền vững của Tập đoàn.",
    ],
  },
  {
    slug: "unik-green",
    name: "Unik Green",
    name_vi: "Unik Green",
    focus: "Wellness Estate Development & Operations",
    focus_vi: "Quản lý vận hành & Phát triển bất động sản nghỉ dưỡng",
    sector: "Real Estate / Healthcare",
    sector_vi: "Bất động sản / Chăm sóc sức khỏe",
    keyAssets: ["Chitta Retreat"],
    keyAssets_vi: ["Chitta Retreat"],
    img: PORTFOLIO_IMG.chittaRetreat,
    short: "Wellness Estate Development & Operations",
    short_vi: "Quản lý vận hành & Phát triển bất động sản Wellness",
    body: [
      "Unik Green is the Group's wellness real estate and destination development platform, focused on building institutional-grade wellness environments that integrate hospitality, nature, and long-term community living.",
      "The platform develops and manages wellness estates, hospitality infrastructure, and integrated lifestyle destinations designed to support preventive health, longevity, and quality of life.",
      "Its flagship asset, Chitta Retreat, is an 81-hectare wellness estate in Phu Tho Province, Vietnam, master-planned to combine hospitality, wellness residences, and health-focused living environments.",
      "As the Group's wellness infrastructure platform, Unik Green translates the healthspan thesis into scalable built environments designed for long-term ownership and enduring asset value.",
    ],
    body_vi: [
      "Unik Green là doanh nghiệp phát triển bất động sản nghỉ dưỡng và các điểm đến du lịch thuộc hệ sinh thái Tập đoàn. Mục tiêu của đơn vị tập trung vào việc kiến tạo không gian nghỉ dưỡng đẳng cấp, đạt tiêu chuẩn quốc tế, nơi kết hợp hài hòa giữa dịch vụ cao cấp, thiên nhiên nguyên sơ và cộng đồng gắn kết bền vững.",
      "Mô hình hoạt động của doanh nghiệp bao gồm quản lý và phát triển các khu bất động sản nghỉ dưỡng, hạ tầng chăm sóc sức khoẻ và các tổ hợp định hình phong cách sống, được thiết kế tối ưu nhằm thúc đẩy xu hướng chăm sóc sức khoẻ chủ động, gia tăng tuổi thọ và nâng cao chất lượng sống.",
      "Dự án trọng điểm của Unik Green là tổ hợp Chitta Retreat - một quần thể bất động sản quy mô 81 ha tại tỉnh Phú Thọ, Việt Nam, được quy hoạch tổng thể, tích hợp đa chức năng giữa biệt thự nghỉ dưỡng, phân khu chăm sóc sức khỏe và môi trường sống sinh thái lành mạnh.",
      "Tập trung phát triển hạ tầng chăm sóc sức khỏe - nghỉ dưỡng theo tầm nhìn chiến lược của Tập đoàn, Unik Green hướng đến việc đưa các luận điểm về khoa học trường thọ ứng dụng trong các không gian sống đạt chuẩn, có tiềm năng nhân rộng quy mô, bảo đảm quyền sở hữu lâu dài và giá trị tài sản bền vững theo thời gian.",
    ],
  },
  {
    slug: "chitta-group",
    name: "Chitta Group",
    name_vi: "Chitta Group",
    focus: "Integrated Healthcare System",
    focus_vi: "Hệ thống Chăm sóc sức khoẻ tích hợp & Phát triển nền tảng tri thức",
    sector: "Healthcare",
    sector_vi: "Chăm sóc sức khỏe",
    keyAssets: ["Chitta Healthspan Institute", "Chitta Center Hanoi", "Chitta Retreat"],
    keyAssets_vi: ["Viện Nghiên cứu Healthspan Chitta", "Chitta Center Hà Nội", "Chitta Retreat"],
    keyAssetsLabel: "Featured Models",
    keyAssetsLabel_vi: "Mô hình đặc trưng",
    img: PORTFOLIO_IMG.chittaHealthspan,
    short: "Integrated Healthcare System",
    short_vi: "Hệ thống Chăm sóc sức khỏe tích hợp",
    body: [
      "Chitta Group is the Group's integrated healthcare, healthspan, and human capital platform, responsible for clinical operations, preventive healthcare systems, education, and intellectual property development.",
      "Operating through Chitta Healthspan Institute, Chitta Center Hanoi, and the clinical ecosystem embedded within Chitta Retreat, the platform develops evidence-based healthspan programmes, medical governance frameworks, and applied research initiatives.",
      "Chitta Group integrates clinical medicine, healthspan science, lifestyle interventions, and technology-enabled healthcare systems to support long-term preventive health and human performance.",
      "As the Group's healthcare and intellectual capital platform, Chitta Group advances the operational and scientific foundation of the broader healthspan ecosystem across Vietnam and Southeast Asia.",
    ],
    body_vi: [
      "Là đơn vị thành viên của Tập đoàn, Chitta Group định hướng kiến tạo mạng lưới tích hợp chăm sóc sức khỏe, khoa học trường thọ và phát triển nguồn nhân lực chất lượng cao, triển khai các hoạt động nghiên cứu lâm sàng, y tế dự phòng, giáo dục và củng cố nền tảng tri thức.",
      "Thông qua hệ sinh thái bao gồm Viện Nghiên cứu Healthspan Chitta, Chitta Center Hà Nội và Chitta Retreat, đơn vị tập trung xây dựng chương trình chăm sóc sức khỏe dựa trên nền tảng y học thực chứng, khung quản trị y khoa chuẩn mực và các sáng kiến nghiên cứu ứng dụng tiên tiến nhất.",
      "Chitta Group hướng đến mục tiêu tích hợp nghiên cứu lâm sàng, khoa học trường thọ, công nghệ tiến tiến và giải pháp thay đổi lối sống, nhằm nâng cao năng lực y học dự phòng, qua đó giúp con người duy trì thể trạng khỏe mạnh trong thời gian dài.",
      "Giữ vị trí chiến lược trong lĩnh vực chăm sóc sức khoẻ và xây dựng nền tảng tri thức của Tập đoàn, Chitta Group từng bước củng cố nền móng khoa học và năng lực vận hành cho toàn bộ hệ sinh thái chăm sóc sức khỏe tại Việt Nam cũng như khu vực Đông Nam Á.",
    ],
  },
];

/* ------------------------------------------------------------------ */
/* Portfolio Assets                                                    */
/* Order: Berriver → Thang Long → Living Space Dong Anh                */
/*        → Chitta Center Hanoi → Chitta Retreat                       */
/* ------------------------------------------------------------------ */
export const PORTFOLIO_ASSETS = [
  {
    slug: "berriver-long-bien",
    name: "Berriver Long Bien",
    name_vi: "Berriver Long Biên",
    type: "Residential",
    type_vi: "Nhà ở thương mại",
    location: "390 Nguyen Van Cu, Long Bien, Hanoi",
    location_vi: "390 Nguyễn Văn Cừ, Long Biên, Hà Nội",
    scale: "34,527 m² · 1,016 apartments",
    scale_vi: "34,527 m² | 1,016 căn hộ",
    investment: "VND 2,191 bn (~USD 83M)",
    metric: "1,016",
    unit: "Units",
    unit_vi: "Căn hộ",
    img: PORTFOLIO_IMG.berriver,
    keyData: [
      { k: "Total Investment", v: "VND 2,191 billion (~USD 83M)" },
      { k: "Location", v: "390 Nguyen Van Cu, Long Bien District, Hanoi" },
      { k: "Project Type", v: "Residential" },
      { k: "Scale", v: "34,527 m² | 1,016 apartments | 5 towers (18–25 floors) + 1 kindergarten" },
      { k: "Open Space", v: "62% landscaped and communal environments" },
      { k: "Status", v: "Completed & Handed Over" },
    ],
    keyData_vi: [
      { k: "Địa điểm", v: "390 Nguyễn Văn Cừ, Long Biên, Hà Nội" },
      { k: "Loại hình", v: "Nhà ở thương mại" },
      { k: "Quy mô", v: "34,527 m² | 1,016 căn hộ | 5 toà nhà (18 - 25 tầng) + 1 trường mầm non" },
      { k: "Không gian công cộng", v: "62% diện tích dành cho cảnh quan và khu vực sinh hoạt chung" },
      { k: "Trạng thái", v: "Đã hoàn thiện & bàn giao" },
    ],
    body: [
      "Berriver Long Bien represents the Group's long-term approach to residential urban development integrating livability, environmental balance, and community-focused design within one of Hanoi's emerging growth corridors.",
      "With 62% of the site dedicated to landscaped and communal environments, the development reflects the Group's commitment to sustainable urban living and long-term residential value creation.",
    ],
    body_vi: [
      "Berriver Long Biên là dự án tiêu biểu cho tầm nhìn dài hạn của Tập đoàn đối với lĩnh vực bất động sản nhà ở đô thị. Dự án mở ra một không gian cân bằng giữa yếu tố môi trường sinh thái và thiết kế lấy cộng đồng làm trung tâm, toạ lạc tại một trong những hành lang tăng trưởng năng động nhất của Hà Nội.",
      "Với 62% diện tích được ưu tiên dành cho cảnh quan cây xanh và không gian sinh hoạt, tiện ích chung, Berriver Long Biên là lời khẳng định mạnh mẽ cho cam kết của Tập đoàn về một phong cách sống bền vững và kiến tạo giá trị an cư vượt thời gian.",
    ],
  },
  {
    slug: "thang-long-tower",
    name: "Thang Long Tower",
    name_vi: "Toà nhà Thăng Long",
    type: "Office Building",
    type_vi: "Tòa nhà văn phòng",
    location: "98a P. Nguy Nhu Kon Tum, Thanh Xuan, Hanoi",
    location_vi: "98a, P. Ngụy Như Kon Tum, Thanh Xuân, Hà Nội",
    scale: "13,156 m² NLA · 20 floors",
    scale_vi: "13,156 m² | 20 tầng",
    investment: "VND 204 bn (~USD 7.8M)",
    metric: "13,156",
    unit: "m² NLA",
    unit_vi: "m² NLA",
    img: PORTFOLIO_IMG.thangLong,
    keyData: [
      { k: "Total Investment", v: "VND 204 billion (~USD 7.8M)" },
      { k: "Location", v: "98a P. Nguy Nhu Kon Tum, Thanh Xuan, Hanoi" },
      { k: "Project Type", v: "Office Building" },
      { k: "Scale", v: "Total NLA 13,156 m² | 20 floors + 2 basements" },
      { k: "Status", v: "Operating since 2008" },
    ],
    keyData_vi: [
      { k: "Địa điểm", v: "98a, P. Ngụy Như Kon Tum, Thanh Xuân, Hà Nội" },
      { k: "Loại hình", v: "Tòa nhà văn phòng" },
      { k: "Quy mô", v: "Tổng NLA 13,156 m² | 20 tầng nổi + 2 tầng hầm" },
      { k: "Trạng thái", v: "Khai thác vận hành từ năm 2008" },
    ],
    body: [
      "Thang Long Tower is a strategically positioned commercial office asset in Hanoi, supported by active leasing, operational management, and long-term tenant stewardship.",
      "Since 2008, the asset has reflected the Group's disciplined approach to commercial real estate prioritising occupancy stability, tenant relationships, and operational performance to generate resilient recurring income over time.",
      "Through continuous asset management and operational oversight, the property remains an important component of the Group's long-term real asset portfolio.",
    ],
    body_vi: [
      "Toà nhà Thăng Long là tòa nhà văn phòng thương mại sở hữu vị trí chiến lược tại Hà Nội, được vận hành hiệu quả nhờ hoạt động khai thác cho thuê, năng lực vận hành chuyên nghiệp cùng quan hệ khách hàng chặt chẽ.",
      "Khai thác hoạt động kể từ năm 2008 đến nay, mô hình là minh chứng rõ nét chiến lược đầu tư của Tập đoàn ở loại hình bất động sản dịch vụ, trong đó ưu tiên duy trì tỷ lệ cho thuê và tối ưu hiệu suất vận hành.",
      "Thông qua công tác quản lý tài sản và giám sát vận hành chặt chẽ, Toà nhà Thăng Long tiếp tục khẳng định vị thế là một cấu phần quan trọng trong danh mục tài sản của Tập đoàn.",
    ],
  },
  {
    slug: "dong-anh-industrial",
    name: "Dong Anh Landholding",
    name_vi: "Quỹ đất Đông Anh",
    type: "Strategic Landholding",
    type_vi: "Quỹ đất chiến lược",
    location: "Thu Lam Commune, Dong Anh, Hanoi",
    location_vi: "Xã Thư Lâm, Đông Anh, Hà Nội",
    scale: "14,581.2 m²",
    scale_vi: "14,581.2 m²",
    investment: "Strategic landholding",
    metric: "14,581",
    unit: "m²",
    unit_vi: "m²",
    img: "/assets/aq2omkea_living-space.jpg",
    keyData: [
      { k: "Location", v: "Thu Lam Commune, formerly Xuan Non Commune, Dong Anh, Hanoi, Vietnam" },
      { k: "Asset Type", v: "Strategic landholding" },
      { k: "Land Area", v: "14,581.2 m²" },
      { k: "Use", v: "Office facilities and building materials production base" },
      { k: "Status", v: "Existing land asset within the Group's portfolio" },
    ],
    keyData_vi: [
      { k: "Địa điểm", v: "Xã Thư Lâm, (trước đây là xã Xuân Nộn), Đông Anh, Hà Nội, Việt Nam" },
      { k: "Loại hình", v: "Quỹ đất chiến lược" },
      { k: "Quy mô", v: "14,581.2 m²" },
      { k: "Chức năng", v: "Văn phòng và cơ sở sản xuất vật liệu xây dựng" },
      { k: "Trạng thái", v: "Quỹ đất trong danh mục tài sản thực dài hạn của Tập đoàn" },
    ],
    body: [
      "Dong Anh Landholding is a strategic land asset of the Group located in Northern Hanoi, within an area connected to the capital's expanding industrial and infrastructure corridors.",
      "The land is recorded for office facilities and a building materials production base. At this stage, the Group presents the site as an existing landholding within its long-term real asset portfolio.",
      "Any future use, adjustment, or repositioning of the asset will be subject to applicable planning, legal procedures, and approvals from competent authorities.",
    ],
    body_vi: [
      "Quỹ đất Đông Anh là tài sản chiến lược của Tập đoàn tại phía Bắc thành phố Hà Nội, nằm trong vùng quy hoạch kết nối trực tiếp với các hành lang hạ tầng và khu công nghiệp trọng điểm của Thủ đô.",
      "Khu đất hiện được sử dụng làm văn phòng và cơ sở sản xuất vật liệu xây dựng. Tập đoàn xác định đây là quỹ đất dự trữ, phục vụ cho chiến lược phát triển danh mục tài sản trong dài hạn.",
      "Mọi kế hoạch khai thác, chuyển đổi mục đích sử dụng hoặc tái định vị công năng đều sẽ được Tập đoàn tuân thủ nghiêm ngặt theo quy hoạch chung, tuân thủ đầy đủ các thủ tục pháp lý theo quy định của cơ quan chức năng có thẩm quyền.",
    ],
  },
  {
    slug: "chitta-center-hanoi",
    name: "Chitta Center Hanoi",
    name_vi: "Chitta Center Hanoi",
    type: "Urban Healthspan & Longevity Centre",
    type_vi: "Trung tâm Chăm sóc sức khỏe trường thọ",
    location: "No 4 Lieu Giai, Ba Dinh, Hanoi",
    location_vi: "4 Liễu Giai, Ba Đình, Hà Nội",
    scale: "400 m²",
    scale_vi: "400 m²",
    investment: "VND 600 bn (~USD 23M)",
    metric: "400",
    unit: "m²",
    unit_vi: "m²",
    img: PORTFOLIO_IMG.chittaCenter,
    keyData: [
      { k: "Total Investment", v: "VND 600 billion (~USD 23M)" },
      { k: "Location", v: "No 4 Lieu Giai, Ba Dinh, Hanoi, Vietnam" },
      { k: "Asset Type", v: "Urban healthspan and longevity centre" },
      { k: "Scale", v: "400 m²" },
      { k: "Status", v: "Opening in 2027" },
    ],
    keyData_vi: [
      { k: "Địa điểm", v: "4 Liễu Giai, Ba Đình, Hà Nội, Việt Nam" },
      { k: "Loại hình", v: "Trung tâm Chăm sóc sức khỏe trường thọ" },
      { k: "Quy mô", v: "400 m²" },
      { k: "Trạng thái", v: "Dự kiến hoạt động vào năm 2027" },
    ],
    body: [
      "Chitta Center Hanoi is the urban hub of the healthspan platform, combining longevity medicine with regenerative and evidence-based preventive care.",
      "The clinical model features integrated assessments, longitudinal care pathways, and an exclusive membership focused on optimizing nutrition, sleep, movement, and mental fitness.",
    ],
    body_vi: [
      "Trung tâm Chitta mang đến một mô hình healthspan, kết hợp toàn diện giữa y tế dự phòng và phác đồ chăm sóc sức khỏe dựa trên y học thực chứng. Mô hình lâm sàng tại đây được xây dựng xoay quanh quy trình đánh giá tổng thể, lộ trình chăm sóc xuyên suốt và sự đồng hành liên tục cùng hội viên.",
      "Các hạng mục dịch vụ được thiết kế chuyên sâu, bao gồm: chẩn đoán toàn diện, tư vấn y học trường thọ, phác đồ phục hồi và chăm sóc sức khỏe chủ động, cùng chương trình quản trị lối sống bao quát dựa trên các yếu tố về dinh dưỡng, giấc ngủ, vận động và sức khỏe tinh thần.",
    ],
  },
  {
    slug: "chitta-hoa-binh",
    name: "Chitta Retreat",
    name_vi: "Chitta Retreat",
    type: "Wellness Estate & Destination Retreat",
    type_vi: "Quần thể nghỉ dưỡng & chăm sóc sức khỏe",
    location: "Phu Tho Province, Vietnam",
    location_vi: "Tỉnh Phú Thọ, Việt Nam",
    scale: "81 hectares",
    scale_vi: "81 ha",
    investment: "VND 2,000 bn (~USD 76M)",
    metric: "81",
    unit: "ha",
    unit_vi: "ha",
    img: PORTFOLIO_IMG.chittaRetreat,
    keyData: [
      { k: "Total Investment", v: "VND 2,000 billion (~USD 76M)" },
      { k: "Location", v: "Phu Tho Province, Vietnam" },
      { k: "Asset Type", v: "Wellness Estate & Destination Retreat" },
      { k: "Scale", v: "81 hectares" },
      { k: "Distance", v: "~55 minutes from Central Hanoi" },
      { k: "Master Plan", v: "78 villas | 14 ultra-luxury branded villas | 72 integrated wellness suites" },
      { k: "Status", v: "Phase 1 opening 2028. Phase 2 to follow." },
      { k: "Standards", v: "JCI alignment, WELL Building Standard, Green Globe" },
    ],
    keyData_vi: [
      { k: "Địa điểm", v: "Tỉnh Phú Thọ, Việt Nam" },
      { k: "Loại hình", v: "Quần thể nghỉ dưỡng & chăm sóc sức khỏe" },
      { k: "Quy mô", v: "81 ha" },
      { k: "Vị trí", v: "~55 phút di chuyển từ khu vực trung tâm thành phố Hà Nội." },
      { k: "Quy hoạch tổng thể", v: "78 villa | 14 biệt thự siêu sang | 72 căn hộ nghỉ dưỡng tích hợp toàn diện." },
      { k: "Tiến độ dự án", v: "Giai đoạn 1 khai trương vào năm 2028. Giai đoạn 2 triển khai sau đó." },
      { k: "Tiêu chuẩn", v: "Kỳ vọng đáp ứng chuẩn JCI, tiêu chuẩn xây dựng WELL, Green Globe." },
    ],
    body: [
      "Chitta Retreat is the flagship expression of the Group's long-term healthspan vision, an integrated wellness estate designed to redefine how people live, heal, recover, and age in the future.",
      "Situated across 81 hectares in Phu Tho Province, Vietnam, the destination combines wellness hospitality, preventive healthcare, longevity-focused living, and nature-based environments within a single institutional-grade ecosystem.",
      "The master plan integrates clinical, residential, and retreat precincts anchored by a centrally positioned medical and healthspan facility, supported by movement and recovery spaces, therapeutic landscapes, nutrition-focused environments, and wellness residences designed for long-term well-being.",
      "Operated under the Chitta clinical and healthspan model, the retreat is designed as a scalable platform for preventive healthcare, wellness living, and human performance. Development is being executed in phases, with Phase 1 scheduled to open in 2028.",
    ],
    body_vi: [
      "Chitta Retreat là dự án tiêu biểu cho tầm nhìn dài hạn của Tập đoàn về tương lai sống khỏe bền vững. Đây là một tổ hợp bất động sản nghỉ dưỡng tích hợp, được thiết kế nhằm tái định nghĩa lối sống khoẻ, cách chữa lành, phục hồi và an dưỡng trong tương lai.",
      "Trải rộng trên diện tích 81 ha tại tỉnh Phú Thọ, quần thể kết hợp hài hòa giữa dịch vụ nghỉ dưỡng, y học dự phòng, không gian sống trường thọ và môi trường thiên nhiên nguyên bản trong một hệ sinh thái đẳng cấp.",
      "Quy hoạch tổng thể của dự án tích hợp các phân khu nghiên cứu lâm sàng, khu nghỉ dưỡng và khu dân cư cao cấp, lấy trung tâm nghiên cứu chăm sóc sức khỏe trường thọ làm tâm điểm. Hệ sinh thái này được cộng hưởng cùng các không gian vận động và phục hồi trị liệu chuyên sâu, cũng như chế độ dinh dưỡng, các biệt thự nghỉ dưỡng được thiết kế riêng cho mục tiêu sống khỏe lâu dài.",
      "Vận hành theo mô hình đặc biệt của Chitta, tổ hợp được định vị là mô hình kiểu mẫu, có thể nhân rộng ở quy mô lớn nhằm thúc đẩy y tế dự phòng, lối sống lành mạnh và giúp con người duy trì thể trạng khỏe mạnh. Dự án đang được triển khai theo lộ trình phân kỳ, trong đó Giai đoạn 1 dự kiến chính thức khai trương hoạt động vào năm 2028.",
    ],
  },
];

/* ------------------------------------------------------------------ */
/* Leadership                                                          */
/* ------------------------------------------------------------------ */
export const LEADERSHIP = [
  {
    slug: "tuan-tran-ngoc",
    name: "Tuan Tran Ngoc",
    name_vi: "Ông Trần Ngọc Tuấn",
    role: "Chairman & CEO of Unik Holdings",
    role_vi: "Chủ tịch & CEO Unik Holdings",
    nationality: "Vietnamese",
    img: "/assets/3lbmsc79_Mr-Sam.jpg",
    short:
      "Leading the Group's development strategy with over 23 years of investment and enterprise development experience.",
    short_vi:
      "Dẫn dắt chiến lược phát triển của Tập đoàn với hơn 23 năm kinh nghiệm đầu tư và phát triển doanh nghiệp.",
    overview: [
      "Tuan Tran is leading the Group's development strategy with over 23 years of experience in investment and enterprise development with a vision to build an integrated ecosystem of enterprises grounded in sustainable development.",
      "Under his leadership, the Group is guided by disciplined capital allocation, strong governance standards, and a long-term investment philosophy. He focuses on developing scalable platforms that integrate real estate, healthcare, and education, aligning business growth with social and environmental responsibility.",
      "With a leadership style grounded in strategic clarity and execution discipline, Tuan Tran is shaping Unik Holdings as a forward-looking investment platform, driving sustainable growth and creating enduring value.",
    ],
    overview_vi: [
      "Với hơn 23 năm kinh nghiệm trong lĩnh vực đầu tư và quản trị doanh nghiệp, ông Trần Ngọc Tuấn là người hoạch định chiến lược phát triển của Tập đoàn. Tầm nhìn của ông hướng tới việc xây dựng một hệ sinh thái doanh nghiệp tích hợp toàn diện, lấy phát triển bền vững làm kim chỉ nam.",
      "Dưới sự dẫn dắt của ông, Unik Holdings luôn kiên định với triết lý đầu tư dài hạn, vận hành dựa trên quy trình quản trị và cơ chế phân bổ nguồn vốn chặt chẽ. Ông tập trung phát triển các mô hình doanh nghiệp có tiềm năng mở rộng quy mô, đồng thời đảm bảo hài hoà giữa mục tiêu tăng trưởng kinh doanh ở ba lĩnh vực cốt lõi: bất động sản, chăm sóc sức khoẻ và giáo dục gắn với trách nhiệm xã hội và bảo vệ môi trường.",
      "Bằng tư duy chiến lược sắc bén cùng phong cách lãnh đạo quyết liệt, ông Tuấn từng bước định hình Unik Holdings trở thành một tập đoàn đầu tư có tầm nhìn dài hạn, thúc đẩy các động lực tăng trưởng bền vững.",
    ],
    education: ["Master of Finance, University of Technology Sydney, Australia"],
    education_vi: ["Thạc sĩ Tài chính tại Đại học Công nghệ Sydney (UTS), Australia."],
    experience: [
      "Chairman — Tipharco Pharmaceutical",
      "Former CEO & Chairman, Handico Finance Joint Stock Company",
      "Former Chairman, Thang Long Meritz Fund Management",
    ],
    experience_vi: [
      "Chủ tịch HĐQT - Công ty Cổ phần Dược phẩm Tipharco",
      "Cựu Chủ tịch & CEO - Công ty Tài chính Cổ phần Handico (HFC)",
      "Cựu Chủ tịch - Công ty Cổ phần Quản lý Quỹ Thăng Long Meritz",
    ],
  },
  {
    slug: "anthony-jude-tan",
    name: "Anthony Jude Tan",
    name_vi: "Ông Anthony Jude Tan",
    role: "Vice Chairman of Strategic Executive Governance Council (SEGC)",
    role_vi: "Phó Chủ tịch Hội đồng Chiến lược & Quản trị thực thi (SEGC)",
    nationality: "Singaporean",
    img: "/assets/gp5i993u_Anthony-Jude-Tan.jpg",
    short:
      "Pioneer of medical wellness and preventive health in Asia with over four decades of experience.",
    short_vi:
      "Với hơn 40 năm kinh nghiệm, ông là người tiên phong trong lĩnh vực chăm sóc sức khỏe và y học dự phòng tại châu Á.",
    overview: [
      "Anthony Jude Tan is the Vice Chairman of the Strategic Executive Governance Council (SEGC) at Unik Holdings, where he leads the Group's medical strategy and supports the development of internationally aligned healthcare initiatives.",
      "Widely recognised as one of Asia's early pioneers in medical wellness and preventive health, Anthony Jude Tan has spent more than four decades shaping the intersection of healthcare, hospitality, and human longevity.",
      "Over the course of his career, he has led more than 30 large-scale projects globally and mobilized over USD 100 million in investment.",
      "At Unik Holdings, he works closely with the leadership team to develop internationally benchmarked models, strengthening the Group's position in preventive healthcare and advancing wellness standards in Vietnam.",
    ],
    overview_vi: [
      "Trên cương vị Phó Chủ tịch Hội đồng Chiến lược và thực thi tại Unik Holdings, ông Anthony Jude Tan đảm nhận vai trò định hình chiến lược y khoa của Tập đoàn, đồng thời thúc đẩy các sáng kiến chăm sóc sức khỏe theo tiêu chuẩn quốc tế.",
      "Được biết tới là một trong những người tiên phong đặt nền móng cho lĩnh vực wellness và y học dự phòng tại châu Á, ông có hơn 40 năm kinh nghiệm trong nhiều lĩnh vực như chăm sóc sức khỏe, dịch vụ khách sạn cao cấp và khoa học trường thọ.",
      "Ông Anthony đã trực tiếp lãnh đạo hơn 30 dự án quy mô lớn trên phạm vi toàn cầu và huy động thành công hơn 100 triệu USD nguồn vốn đầu tư.",
      "Tại Unik Holdings, ông phối hợp chặt chẽ với Ban Lãnh đạo Tập đoàn nhằm xây dựng các mô hình chăm sóc sức khỏe đạt chuẩn quốc tế, qua đó củng cố vị thế vững chắc của doanh nghiệp trong lĩnh vực y học dự phòng và nâng tầm các tiêu chuẩn sống khỏe tại Việt Nam.",
    ],
    education: [
      "MBA, International Executive School (IES), Strasbourg, France",
      "PhD Candidate in Medical Wellness and Healthspan",
    ],
    education_vi: [
      "MBA từ International Executive School (IES), Strasbourg, Pháp.",
      "Nghiên cứu sinh Tiến sĩ chuyên ngành Y học Wellness và Healthspan.",
    ],
    experience: [
      "Managing Director & Founder, AJT Wellity Asia Co., Ltd.",
      "Director & CEO, AG BioMed Co., Ltd.",
      "Advisor & Managing Director, iRETREAT Wellness Meditation Group",
      "Advisor, Thai Lifestyle & WellBeing Association",
      "Co-Vice Chairman, We Are The World Global Summit",
      "Strategic Advisor, GutLinx Sdn Bhd",
      "Former CEO, VitalLife Corporation – preventive healthcare arm of Bumrungrad International Hospital (Thailand)",
      "Strategic leader behind the launch of TRIA International Wellness",
    ],
    experience_vi: [
      "Nhà sáng lập kiêm Giám đốc Điều hành - AJT Wellity Asia Co.,Ltd.",
      "CEO & Giám đốc – AG BioMed Co.,Ltd.",
      "Cố vấn & Giám đốc Điều hành - iRETREAT Wellness Meditation Group",
      "Cố vấn - Hiệp hội Lối sống lành mạnh & Chăm sóc sức khoẻ Thái Lan",
      "Phó Chủ tịch Hội nghị Thượng đỉnh toàn cầu \"We Are The World\"",
      "Cố vấn Chiến lược - GutLinx Sdn Bhd",
      "Cựu CEO - VitalLife Corporation (đơn vị chuyên trách về y học dự phòng thuộc Bệnh viện Quốc tế Bumrungrad, Thái Lan)",
      "Lãnh đạo chiến lược đứng sau sự ra mắt TRIA International Wellness - mô hình tiên phong tích hợp giữa chăm sóc sức khoẻ chủ động và dịch vụ nghỉ dưỡng cao cấp.",
    ],
  },
  {
    slug: "nghia-nguyen-chinh",
    name: "Nghia Nguyen Chinh",
    name_vi: "Ông Nguyễn Chính Nghĩa",
    role: "Vice Chairman of Strategic Executive Governance Council (SEGC)",
    role_vi: "Phó Chủ tịch Hội đồng Chiến lược & Quản trị thực thi (SEGC)",
    nationality: "Vietnamese",
    img: "/assets/i0nn34x5_Mr-Taran.jpg",
    short:
      "Over 20 years of expertise across accounting, auditing, financial analysis, corporate strategy, and enterprise governance.",
    short_vi:
      "Hơn 20 năm kinh nghiệm trong các lĩnh vực kế toán, kiểm toán, phân tích tài chính, chiến lược doanh nghiệp và quản trị doanh nghiệp.",
    overview: [
      "Nghia Nguyen is a Board Member and Vice Chairman of the Strategic Executive Governance Council (SEGC) at Unik Holdings, where he shapes the Group's strategic direction and leads investment initiatives within its healthcare ecosystem.",
      "With over 20 years of experience in accounting, auditing, financial analysis, corporate strategy, and enterprise governance, he brings strong expertise in financial management, risk oversight, and execution governance.",
    ],
    overview_vi: [
      "Ông Nguyễn Chính Nghĩa là Thành viên HĐQT kiêm Phó Chủ tịch Hội đồng Chiến lược và thực thi tại Unik Holdings. Ông đóng vai trò quan trọng trong việc định hình chiến lược tổng thể và dẫn dắt các sáng kiến đầu tư trong hệ sinh thái chăm sóc sức khoẻ của Tập đoàn.",
      "Với hơn 20 năm kinh nghiệm trong các lĩnh vực kế toán, kiểm toán, phân tích tài chính, hoạch định chiến lược và quản trị doanh nghiệp, ông sở hữu năng lực chuyên môn sâu rộng về quản trị tài chính, kiểm soát rủi ro và điều hành hệ thống.",
    ],
    education: ["Master in Financial Control & Audit Management, France"],
    education_vi: ["Thạc sĩ chuyên ngành Kiểm toán & Kiểm soát tài chính tại Pháp."],
    experience: [
      "Director, Center for Community Healthcare and Communication",
      "Co-Founder & Board Member, Unik Holdings",
    ],
    experience_vi: [
      "Giám đốc Trung tâm Truyền thông và Chăm sóc Sức khỏe Cộng đồng",
      "Đồng sáng lập kiêm Thành viên HĐQT Unik Holdings",
    ],
  },
];

export const findAsset = (slug) => PORTFOLIO_ASSETS.find((a) => a.slug === slug);
export const findCompany = (slug) => PORTFOLIO_COMPANIES.find((c) => c.slug === slug);
export const findLeader = (slug) => LEADERSHIP.find((l) => l.slug === slug);
